




























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = "datav/money";

  columns: any[] = [
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户名", dataIndex: "username" },
    { title: "手机号", dataIndex: "user_mobile" },
    {
      title: "金额",
      customRender: (text: any, record: any, index: any) => record.cost / 100
    },
    { title: "时间", dataIndex: "created_time" }
  ];

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId,
        item: "money"
      },
      false
    );
  }
}
